import { Box, ListItem, Stack, UnorderedList } from '@chakra-ui/react';
import Card from '@components/atoms/Card';
import Button from '@components/interactive/Button';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';

type Props = {
  title: string;
  items: any;
  link?: {
    elementId: string;
    href: string;
    text: string;
  };
};

function InfoCard({ title, link, items }: Props) {
  return (
    <Card>
      <Stack align="left" textAlign="left">
        <Box p={[6, 8]}>
          <Header as="h4" mb={4}>
            {title}
          </Header>
          {link ? (
            <Button id={link.elementId} href={link.href} target="_blank" width="100%" maxW="300px">
              {link.text}
            </Button>
          ) : null}
          {Array.isArray(items) ? (
            <UnorderedList>
              {items.map((item, i) => (
                <ListItem key={i} fontSize="lg">
                  {item}
                </ListItem>
              ))}
            </UnorderedList>
          ) : (
            <>
              {Object.keys(items).map((key, i) => (
                <Stack key={i}>
                  <Box mt={4} w={['100%', '100%', 300]} py={2}>
                    <Body1 bold>{key}</Body1>
                  </Box>
                  <UnorderedList mb={5} pl={5}>
                    {items[key].map((child, i) => (
                      <ListItem key={i} fontSize="lg">
                        {child}
                      </ListItem>
                    ))}
                  </UnorderedList>
                </Stack>
              ))}
            </>
          )}
        </Box>
      </Stack>
    </Card>
  );
}

export default InfoCard;
